var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"gray-box background-border-gray border-radius-regular position-relative overflow-hidden",class:`gray-box-${_vm.type}`})
}
var staticRenderFns = []

export { render, staticRenderFns }